import { Component, OnInit } from "@angular/core";
import { AuthorizationPipe } from "../../common/pipes/authorization.pipe";
import { DataShareService } from "../../shared/services/data.service";
import { CommonService } from "../../shared/services/common.service";
@Component({
    selector: "email-tickets",
    templateUrl: "../templates/template1/views/email-tickets.component.html",
    styleUrls: [
        "../templates/template1/themes/default/css/ticket.less"
    ]
})
export class EmailTicketsComponent implements OnInit {
    rightContentWidth: number = 1000;
    constructor(private _dataShareService: DataShareService
         , private _commonService: CommonService) {

    }
    ngOnInit(): void {
        this.activetab = 1;
        this._dataShareService.customerServiceMessage.subscribe(message => {
            if (message && message !== '') {
                var splittedMessage = message.split('-');
                this.rightContentWidth = parseInt(splittedMessage[0])   ;
                // this.searchScreenWidth = this.viewRightPanel ? (rightContentWidth - 260) : rightContentWidth;
                // this.applyMD4Class = this.searchScreenWidth === 834 ? true : false;
            }
        });
    };
    activetab: number;
    selectTab(tab: any) {
        this.activetab = tab;
    }
    changeTab(tab: any) {
        this.activetab = tab;
    }
}


// WEBPACK FOOTER //
// ./src/app/customerservice/components/email-tickets.component.ts